import { faArrowDown, faArrowUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Grid, IconButton, Typography } from '@mui/material';
import React, { Component } from 'react';
import { MOVE_WIDGET_DOWN, MOVE_WIDGET_UP } from '../../../common/constants';
import PortalTooltip from '../../../common/PortalTooltip';

class WidgetCard extends Component {
  state = {};

  //θ(1) Returns the tooltip title for move arrows on widget card
  getTitle = (direction, position) => {
    return 'Move ' + this.props.widget.title + ' ' + direction + ' to position ' + position;
  };

  render() {
    return (
      <React.Fragment>
        {/* //TODO: move this inline style to scss file */}
        <Card
          sx={{
            marginBottom: '0.5rem',
            p: 1,
            width: '100%',
          }}
          className={'myOdu__appCard'}
          elevation={0}
        >
          {/* //TODO: move inline style to scss */}
          <Grid
            container
            direction={'row'}
            wrap="nowrap"
            style={{
              ...(this.props.hideUp && this.props.hideDown
                ? { border: 0, width: 'auto' }
                : { width: 'auto' }),
            }}
            alignItems={'center'}
          >
            <Grid item container xs="auto" direction={'row'} wrap="nowrap">
              <Grid item visibility={this.props.hideUp ? 'hidden' : 'visible'}>
                <PortalTooltip
                  title={this.getTitle('up', this.props.index)}
                  enterDelay={850}
                  enterNextDelay={850}
                >
                  <IconButton
                    sx={{ p: 3 }}
                    className="myOdu__iconButton widgetUp"
                    id={'settings__button_widgetCard_' + this.props.widget.id + '_up'}
                    onClick={() =>
                      this.props.moveWidget(
                        this.props.widget.id,
                        this.props.sectionNumber,
                        MOVE_WIDGET_UP,
                      )
                    }
                    style={this.props.hideUp ? { opacity: 0 } : {}}
                    disabled={this.props.hideUp}
                  >
                    <FontAwesomeIcon icon={faArrowUp} size="sm" />
                  </IconButton>
                </PortalTooltip>
              </Grid>
              <Grid item visibility={this.props.hideDown ? 'hidden' : 'visible'}>
                <PortalTooltip
                  title={this.getTitle('down', this.props.index + 2)}
                  enterDelay={850}
                  enterNextDelay={850}
                >
                  <IconButton
                    sx={{ p: 3 }}
                    className="myOdu__iconButton widgetDown"
                    id={'settings__button_widgetCard_' + this.props.widget.id + '_down'}
                    onClick={() =>
                      this.props.moveWidget(
                        this.props.widget.id,
                        this.props.sectionNumber,
                        MOVE_WIDGET_DOWN,
                      )
                    }
                    style={this.props.hideDown ? { opacity: 0 } : {}}
                    disabled={this.props.hideDown}
                  >
                    <FontAwesomeIcon icon={faArrowDown} size="sm" />
                  </IconButton>
                </PortalTooltip>
              </Grid>
            </Grid>

            <Grid item sx={{ ml: 1 }} style={{ cursor: 'pointer' }}>
              <Typography variant="h6" component="h4">
                {this.props?.widget?.title}
              </Typography>
            </Grid>
          </Grid>
        </Card>
      </React.Fragment>
    );
  }
}

export default WidgetCard;
